/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSouscriptionActivePolicyQuery = gql`
  query GetSouscriptionActivePolicyQuery {
    getSouscriptionActivePolicy_souscription_active_policy {
      customer {
 activePolicies {
 contractNumber  
cancellationApplicant  
name  
emails {
 value  
type  
} 
addresses {
 fields  
city  
zipCode  
} 
requestedCancellationDate  
} 
}
      company {
 activePolicies {
 contractNumber  
cancellationApplicant  
name  
emails {
 value  
type  
} 
addresses {
 fields  
city  
zipCode  
} 
requestedCancellationDate  
} 
}
      offerCode 
      effectDate 
      teamIdJrmc 
    }
  }
`;

export default GetSouscriptionActivePolicyQuery;
